
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class AppHideText extends Vue {
  @Prop({
    required: true,
  })
  public readonly value!: string;

  @Prop({
    default: false,
  })
  public readonly show!: boolean;

  @Prop({
    default: "*",
  })
  public readonly maskingSymbol!: string;

  private get maskedValue(): string {
    const valueLength = this.value.length;

    const maskedLength = Math.floor((valueLength * 3) / 4);
    const unmasked = this.value.substring(0, valueLength - maskedLength);

    return `${unmasked}${this.maskingSymbol.repeat(maskedLength)}`;
  }

  public get hiddenValue(): string {
    if (this.show) {
      return this.value;
    }
    return this.maskedValue;
  }
}
